module.exports = "/images/paymaya.png";